"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants = {
  borderRadius: "4px",
  borderWidth: "1px",
  boxShadow: "0 0 12px 0 rgba(0,0,0,0.1)",
  boxShadowHover: "0 0 16px 0 rgba(0,0,0,0.2)"
};

exports.default = constants;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-theme/dist/constants.js
// module id = 456
// module chunks = 168707334958949